import axios from "axios";

export const commentAxios = axios.create({
    headers: {
        post: {'Content-Type': 'application/json'}
    },
    baseURL: '/rest'
});
